export const environment = {
  production: false,
  apiUrl: 'https://gcp-afp-autoatencion-cr-bff-254417327562.us-east1.run.app/api/v1'
};
